export const GET_LIST_QUANLYCONGVIEC = "GET_LIST_QUANLYCONGVIEC";
export const GET_LIST_QUANLYCONGVIEC_SUCCESS =
  "GET_LIST_QUANLYCONGVIEC_SUCCESS";
export const GET_LIST_QUANLYCONGVIEC_FAILURE =
  "GET_LIST_QUANLYCONGVIEC_FAILURE";
